export const GET_TOURNAMENT_DATA = 'GET_TOURNAMENT_DATA'
export const GET_TOURNAMENT_DATA_REG = 'GET_TOURNAMENT_DATA_REG'
export const GET_REGISTERING_TOURNAMENTS = 'GET_REGISTERING_TOURNAMENTS'
export const GET_RUNNING_TOURNAMENTS = 'GET_RUNNING_TOURNAMENTS'
export const GET_RANDOM_TOURNAMENT = 'GET_RANDOM_TOURNAMENT'